export const CLEAR_AUTOFILL_SUGGESTION_REQUEST = 'autofill/CLEAR_AUTOFILL_SUGGESTION_REQUEST';
export const CLEAR_AUTOFILL_SUGGESTION_SUCCESS = 'autofill/CLEAR_AUTOFILL_SUGGESTION_SUCCESS';
export const CLEAR_AUTOFILL_SUGGESTION_FAILURE = 'autofill/CLEAR_AUTOFILL_SUGGESTION_FAILURE';
